import { useMemo } from 'react';

import useAxios from 'axios-hooks';

import { url } from 'constants/index';
import { EntityTypes } from 'contexts/EntityTypesContext';
import { buildRequestParams } from 'utils/pagination.utils';
interface CurationAllPropertiesArgs {
  entityTypeName: EntityTypes;
  ids: string;
  pageSize: number;
}

interface AllCurationPropertiesReturn {
  curationProperties: { [key: string]: MetaPropertyFieldValue };
  isLoading: boolean;
  refetchCurationProperties: () => void;
}

export const useAllCurationProperties = ({
  entityTypeName,
  ids,
  pageSize,
}: CurationAllPropertiesArgs): AllCurationPropertiesReturn => {
  const [{ data: curationPropertiesData, loading: isLoadingCurationProperties }, refetch] =
    useAxios<PaginationData<CurationProperties>>(
      {
        url: `${entityTypeName}${url.curation_properties}`,
        params: buildRequestParams({
          pageSize,
          filters: [{ columnId: 'entityId', value: ids, condition: 'in' }],
        }),
      },
      { manual: !ids },
    );

  const curationProperties = useMemo(() => {
    if (!curationPropertiesData?.items) {
      return {};
    }
    return curationPropertiesData.items.reduce((result, item) => {
      if (Object.keys(item.curationProperties).length) {
        result[item.entityId] = item.curationProperties;
      }
      return result;
    }, {});
  }, [curationPropertiesData]);

  return {
    curationProperties,
    isLoading: isLoadingCurationProperties,
    refetchCurationProperties: refetch,
  };
};
